module.exports = __webpack_public_path__ + "img/galet_marbre_gris_bleu.d972099c.jpg";